import styled from "styled-components";
import {SearchPCIconBoxDefault} from "./search-pc-icon.default.box";
import {SearchInputFormBox} from "../search-input-form/search-input-form.box";

export const SearchPCIconCasino777Box = styled(SearchPCIconBoxDefault)`
    background-position: -453px -581px;

    ${SearchInputFormBox}:hover & {
        background-position: -488px -581px;
    }
`;